import { DISCOVERY_STATE_ACTIONS, DiscoveryState, DiscoveryStateActions } from './types';

const initialState: DiscoveryState = {
  showSearchResults: false,
};

export const discoveryReducer = (state = initialState, action: DiscoveryStateActions): DiscoveryState => {
  switch (action.type) {
    case DISCOVERY_STATE_ACTIONS.SET_SHOW_SEARCH_RESULTS:
      return {
        ...state,
        showSearchResults: action.payload,
      };
    default:
      return state;
  }
};
